import React, { Suspense } from 'react';
import {
  Box,
  Text,
  Icon,
  IconSize,
  SideSheet,
  SideSheetClose,
  SideSheetBody,
  Spinner,
  SpinnerSize,
  useSideSheetState,
} from '@bechtel/gds';
import { ErrorBoundary } from '@bechtel/client-common';
import { RodRequestDetails } from '~/components/organisms/rod-request-details';
import { t, Trans } from '@lingui/macro';
import { EditRequestBoxStyled, SideSheetHeaderStyled } from './styled';
import { RodRequest } from '@bechtel/types';
import { EditRodRequest } from '~/request/edit/rod-room';
import { useRodRoomPermissions } from '@bechtel/client-weld-common';

interface RodRequestDetailsSideSheetProps {
  rodRequestItem: RodRequest;
  detailsSideSheetVisible: boolean;
  setDetailsSideSheetVisible: (visible: boolean) => void;
}

export const RodRequestDetailsSideSheet: React.FC<RodRequestDetailsSideSheetProps> = ({
  rodRequestItem,
  detailsSideSheetVisible,
  setDetailsSideSheetVisible,
}) => {
  const { visible, open, close } = useSideSheetState(false);
  const { canUpdateRodRequest } = useRodRoomPermissions(
    rodRequestItem?.welds && rodRequestItem?.welds.length > 0 ? rodRequestItem.welds[0].commodityAssignees : []
  );
  return (
    <SideSheet visible={detailsSideSheetVisible}>
      <SideSheetHeaderStyled title={t`Details`}>
        <SideSheetClose onClick={() => setDetailsSideSheetVisible(false)}></SideSheetClose>
      </SideSheetHeaderStyled>
      <SideSheetBody>
        <Box flexDirection={{ sm: 'column' }} css={{ width: '100%' }}>
          {canUpdateRodRequest && (
            <EditRequestBoxStyled onClick={open}>
              <Icon icon="pen-to-square" size={IconSize.MEDIUM} fillColor="white" />
              <Text size="300" family="graphik" color="white">
                <Trans>Edit Request</Trans>
              </Text>
            </EditRequestBoxStyled>
          )}
          <RodRequestDetails rodRequest={rodRequestItem} onClose={() => setDetailsSideSheetVisible(false)} />
        </Box>
      </SideSheetBody>
      <ErrorBoundary>
        <Suspense fallback={<Spinner size={SpinnerSize.LARGE} />}>
          {visible && (
            <EditRodRequest
              rodRequest={rodRequestItem}
              onClose={() => {
                close();
                setDetailsSideSheetVisible(false);
              }}
            />
          )}
        </Suspense>
      </ErrorBoundary>
    </SideSheet>
  );
};
